// ตารางสอนของครูหนึ่งคน (ภาคศาสนา) — ใช้ร่วมกันระหว่างหน้าของฝ่ายการสอนที่เลือกครู
// ได้ (IslamicTeacherTimetable) กับหน้าตารางของตัวเองที่ครูเปิดดูเอง (IslamicMyTimetable)
//
// ช่องหนึ่งเก็บเป็นรายการ ไม่ใช่แถวเดียว — ครูที่ถูกจัดซ้อนสองห้องในคาบเดียวต้องเห็น
// ทั้งคู่ ไม่ใช่ให้ห้องหลังทับห้องแรกหายไป
import React from "react";
import { DAYS, subjectCode, teacherLabel, docOptions } from "../utils/islamicTimetable";

export const roomLabel = (row) => `${row.ic_class}/${row.ir_no}`;

// เอกสารตามภาษาเมนู (ดู docOptions ใน utils/islamicTimetable) — ชื่อครูบนหัวใบและ
// ในชื่อไฟล์ใช้ชื่อภาษาเดียวกับใบ ไม่งั้นใบยาวีจะมีชื่อไทยโผล่อยู่บรรทัดเดียว
export const teacherPrintDoc = ({ periods, grid, teacher, yearLabel, lang, t }) => {
  const tt = t.teacherTimetable;
  const name = teacherLabel(lang, teacher).name;
  return {
    ...docOptions(lang, t, tt),
    title: tt.docTitle(name),
    subtitle: t.common.studyYear(yearLabel),
    periods,
    cellHtml: (day, period) => {
      const cell = grid[day]?.[period.period_id];
      if (!cell) return "";
      return cell.map((slot) => `
        <div style="margin-bottom:2px;">
          <div style="font-weight:600;font-size:10px;">${subjectCode(slot)}</div>
          <div style="font-size:11px;color:#333;">${slot.isubject_name || ""}</div>
          <div style="font-size:10px;color:#555;">${tt.docRoom(roomLabel(slot))}</div>
        </div>`).join("");
    },
    filename: `${tt.docFile(name)}.pdf`,
  };
};

export function TeacherTimetableGrid({ periods, grid, dayNames, labels }) {
  return (
    <table
      className="table table-bordered mb-0"
      style={{ tableLayout: "fixed", minWidth: periods.length * 100 + 80 }}
    >
      <thead className="table-secondary">
        <tr>
          <th style={{ width: 80, fontSize: "0.78rem" }}>{labels.colDay}</th>
          {periods.map((p) => (
            <th key={p.period_id} className="text-center" style={{ fontSize: "0.73rem" }}>
              <div className="fw-semibold">{labels.periodNo(p.period_order)}</div>
              <div className="text-muted fw-normal">{p.period_begin}–{p.period_end}</div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {DAYS.map((d) => (
          <tr key={d}>
            <td className="text-center align-middle fw-semibold" style={{ fontSize: "0.78rem" }}>
              {dayNames[d]}
            </td>
            {periods.map((p) => {
              const cell = grid[d]?.[p.period_id] || [];
              return (
                <td key={p.period_id} style={{ padding: 2, verticalAlign: "top" }}>
                  {cell.length === 0 ? (
                    <div className="text-center text-muted" style={{ fontSize: "0.7rem", padding: "0.5rem 0" }}>
                      {labels.empty}
                    </div>
                  ) : cell.map((slot) => (
                    <div
                      key={slot.is_teachtime_id}
                      className={`rounded p-1 mb-1 text-white ${slot.has_teacher_conflict ? "bg-danger" : "bg-primary"}`}
                      style={{ fontSize: "0.72rem" }}
                    >
                      <div className="fw-semibold" style={{ lineHeight: 1.2, fontSize: "0.66rem" }}>
                        {subjectCode(slot)}
                      </div>
                      <div className="arabic-text" style={{ lineHeight: 1.3, opacity: 0.9 }}>
                        {slot.isubject_name}
                      </div>
                      <div style={{ lineHeight: 1.2, opacity: 0.8 }}>
                        {roomLabel(slot)} ({slot.is_programCode})
                      </div>
                    </div>
                  ))}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
